import { createContext, useContext, useState, useMemo, useCallback } from "react";

const MOCK_PROMOCIONES = [
    {
        id: "promo-1",
        sender: "Coca-Cola",
        senderAvatar: null,
        title: "Coca-Cola Star Wars: Edición Limitada",
        description: "¡Despierta el lado oscuro en tu negocio! Descubre las nuevas latas coleccionables de edición limitada con los personajes más icónicos de Star Wars, como Darth Maul y el Emperador Palpatine.",
        imageUrl: "/promos/promo1.webp",
        actionUrl: "https://www.coca-cola.com",
        actionLabel: "Ver diseños",
        date: "2026-06-14T10:00:00.000Z", // Actualizado al contexto de la campaña activa en 2026
        read: false,
    },
    {
        id: "promo-2",
        sender: "Coca-Cola",
        senderAvatar: null,
        title: "Destapa Coca-Cola y colecciona Panini",
        description: "¡Llegó la Copa Mundial de la FIFA 26™! Por la compra de 2 Coca-Cola Zero Azúcar (Lata 350, Lata 473 o PET 591 ml) + $500, llévate 1 sobre con 3 láminas especiales de Panini.",
        imageUrl: "/promos/promo2.webp",
        actionUrl: "https://www.coca-cola.com",
        actionLabel: "Ver bases",
        date: "2026-06-12T09:15:00.000Z",
        read: true,
    },
    {
        id: "promo-3",
        sender: "Coca-Cola",
        senderAvatar: null,
        title: "Colecciona los vasos gratis de Coca-Cola",
        description: "Reúne 5 tapas grises marcadas de botellas retornables o Zero Azúcar y canjéalas por 1 vaso de vidrio coleccionable gratis. Promoción válida para Colombia hasta agotar existencias.",
        imageUrl: "/promos/promo3.png",
        actionUrl: "https://www.coca-cola.com/co/es/legal/promo-vasos-cocacola",
        actionLabel: "Puntos de canje",
        date: "2026-06-10T14:30:00.000Z",
        read: true,
    },
    {
        id: "promo-4",
        sender: "Coca-Cola",
        senderAvatar: null,
        title: "Planta de botellas 100% recicladas en Chile",
        description: "Operada por Coca-Cola Andina y Coca-Cola Embonor, ya comenzó a operar la planta que elaborará las primeras botellas con plástico reciclado en Chile y que dará un nuevo ciclo de vida a las botellas, convirtiéndolas en nuevos envases.\n\n#ReCiclar #CocaCola",
        videoUrl: "https://www.youtube.com/embed/tQmF1jO9_Aw",
        actionUrl: "https://youtu.be/tQmF1jO9_Aw?si=tYhgvhoslBfgozSm",
        actionLabel: "Ver en YouTube",
        date: "2026-06-15T10:00:00.000Z",
        read: false,
    },
];

const PromocionesContext = createContext(null);

export const PromocionesProvider = ({ children }) => {
    const [promociones, setPromociones] = useState(MOCK_PROMOCIONES);

    const unreadCount = useMemo(
        () => promociones.filter((p) => !p.read).length,
        [promociones]
    );

    const markAsRead = useCallback((id) => {
        setPromociones((prev) =>
            prev.map((p) => (p.id === id ? { ...p, read: true } : p))
        );
    }, []);

    const markAllAsRead = useCallback(() => {
        setPromociones((prev) => prev.map((p) => ({ ...p, read: true })));
    }, []);

    return (
        <PromocionesContext.Provider
            value={{ promociones, unreadCount, markAsRead, markAllAsRead }}
        >
            {children}
        </PromocionesContext.Provider>
    );
};

export const usePromociones = () => useContext(PromocionesContext);
